// Used for case data where data values have not been set.
export const UNASSIGNED = "Unassigned";
export const UNKNOWN = "Unknown";
export const NONE = "None";
